<script setup>
import PaymentFormCard from "@/components/payments/PaymentFormCard.vue";

defineProps({
  fileName: String,
});

defineEmits(["select-mock-file"]);
</script>
<template>
  <PaymentFormCard
    title="แนบหลักฐานการชำระ"
    subtitle="ในเวอร์ชันนี้เป็น placeholder สำหรับจำลองการแนบสลิปหรือหลักฐานการโอนเงิน"
    icon="bi-paperclip"
  >
    <div class="upload-box text-center p-4">
      <i class="bi bi-cloud-arrow-up fs-1 text-primary d-block mb-3"></i>
      <div class="fw-semibold mb-2">ลากไฟล์มาวาง หรือคลิกเพื่อเลือกไฟล์</div>
      <div class="text-muted small mb-3">
        รองรับไฟล์ .jpg, .png, .pdf (จำลองการอัปโหลด)
      </div>
      <button
        type="button"
        class="btn btn-outline-primary rounded-3"
        @click="$emit('select-mock-file')"
      >
        <i class="bi bi-folder2-open me-2"></i>
        เลือกไฟล์ตัวอย่าง
      </button>
      <div
        v-if="fileName"
        class="alert alert-light border rounded-4 mt-3 mb-0 small text-start"
      >
        <i class="bi bi-file-earmark-check text-success me-2"></i>
        แนบไฟล์แล้ว: <strong>{{ fileName }}</strong>
      </div>
    </div>
  </PaymentFormCard>
</template>

<style scoped>
.upload-box {
  border: 2px dashed #dbe4ff;
  border-radius: 1rem;
  background: rgba(13, 110, 253, 0.03);
}
</style>
